import { combineReducers } from "redux";
import * as types from "../../utils/actionTypes";
import { createReducer } from "../../utils/helpers";

const initialState = {
  config: {
    title: "Budget",
    path: "budget",
    selectionKey: "budget",
    component: "Budget",
    increment: 1000,
    maxBudget: 3000000,
    currency: "CHF",
    ignore: false,
  },
  handle: {
    description: "Stellen Sie mit Hilfe des Sliders Ihr Budget ein:",
    value: 800000,
    leftBound: 400000,
    leftBoundWithPlot: 707000, // try and error
    hasBlock: true,
  },
  blocker: {
    title: "Bauland",
    factor: (budget) => (-0.05 / 1000000) * budget + 0.35,
    auxiliariesShort: "NK",
    auxiliariesLong: "Nebenkosten",
    auxiliaries: (budget) => budget * 0.12,
  },
  calculation: {
    description: "Berechnen Sie Ihr Budget mit Hilfe der Eingabefelder:",
    inputs: ["Ersparnisse", "Wertschriften", "3. Säule", "Pensionskasse"],
    mortgage: 0.8,
  },
  error: {
    title: "Budget erreicht",
    subTitle: "Ihr Budget muss angepasst werden",
    description:
      "Hoppla, Ihr Budget wurde überschritten. Sie können das Budget ganz einfach nach oben anpassen oder sich bei der Konfiguration für günstigere Optionen entscheiden.",
    adjust: "anpassen",
    ignore: "ignorieren",
  },
};

//  Budget Config
const setBudgetIgnore = (state, payload) => ({
  ...state,
  ignore: payload,
});

export const config = createReducer(initialState.config, {
  [types.SET_BUDGET_IGNORE]: setBudgetIgnore,
});

// Budget Handle
const setHandleValue = (state, payload) => ({
  ...state,
  value: payload,
});

const setBlock = (state, payload) => ({
  ...state,
  hasBlock: payload,
});

export const handle = createReducer(initialState.handle, {
  [types.SET_BUDGET_VALUE]: setHandleValue,
  [types.SET_BUDGET_BLOCK]: setBlock,
});

// Budget Blocker
export const blocker = createReducer(initialState.blocker, {});

// Budget Blocker
export const error = createReducer(initialState.error, {});

// Budget Calculation
export const calculation = createReducer(initialState.calculation, {});

// Default Export
export default combineReducers({
  config,
  handle,
  blocker,
  error,
  calculation,
});



// WEBPACK FOOTER //
// ./src/modules/budget/reducers.js